<template>
  <b-row class="admin-campaigns">
    <b-col
      cols="12"
      class="d-flex flex-row justify-content-center align-items-center my-5"
      v-if="$apollo.loading"
    >
      <b-spinner type="grow" variant="primary"/>
    </b-col>
    <b-col cols="12" class="px-4 pt-1" v-else>

      <b-row>
        <b-col v-if="!isSimplifiedCampaign" class="pt-3 pl-3 pr-1 left-menu" cols="12" md="3" lg="2">
          <b-card no-body>
            <!-- Campaigns -->
            <div
              class="p-3 menu-item border-bottom"
              :class="{ active: $route.name === 'CampaignAdmin', 'text-primary':  $route.name === 'CampaignAdmin' }"
              @click="$router.push({ name: 'CampaignAdmin' })"
            >
              <font-awesome-icon class="mr-3" icon="calendar"/>{{ $t('campaign-admin.titles.campaigns') }}
            </div>
            <!-- Users -->
            <div class="p-3 menu-item border-bottom">
              <font-awesome-icon class="mr-3" icon="user"/>{{ $t('navigation.users') }}
            </div>
            <!-- Candidates -->
            <div class="p-3 menu-item border-bottom">
              <font-awesome-icon class="mr-3" icon="user-tie"/>{{ $t('campaign-admin.titles.candidates') }}
            </div>
            <!-- Analytics -->
            <div
              class="p-3 menu-item border-bottom"
              :class="{ active: $route.name === 'CampaignAnalytics', 'text-primary':  $route.name === 'CampaignAnalytics'  }"
              @click="$router.push({ name: 'CampaignAnalytics' })"
            >
              <font-awesome-icon class="mr-3" icon="chart-line"/>{{ $t('navigation.analytics') }}
            </div>
            <!-- Settings -->
            <div
              class="p-3 menu-item"
              :class="{ active: $route.name === 'EmailSetup', 'text-primary':  $route.name === 'EmailSetup'  }"
              @click="$router.push({ name: 'EmailSetup' })"
            >
              <font-awesome-icon class="mr-3" icon="cog"/>{{ $t('navigation.settings') }}
            </div>
          </b-card>
        </b-col>
        <b-col cols="12" :md="isSimplifiedCampaign ? 12 : 9" :lg="isSimplifiedCampaign ? 12: 10" :class="contentClass">
          <slot></slot>
        </b-col>
      </b-row>

    </b-col>
  </b-row>
</template>

<script>
// import { mapRoot } from '@src/mixins/root';

export default {
  name: 'CampaignAdminPage',
  props: {
    contentClass: {
      type: String,
    }
  },
  computed: {
    // ...mapRoot([ 'isSimplifiedCampaign' ]),
    isSimplifiedCampaign() {
      return true;
    }
  }
};
</script>

<style lang="scss">
.admin-campaigns {
  .left-menu {
    .menu-item {
      cursor: pointer;
      &:hover {
        font-weight: bold;
      }
    }
    .active {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/campaign-admin/page.vue